(() => {
      const text = new Map([
        ['Customer Reviews', 'Kundrecensioner'],
        ['Be the first to write a review', 'Bli den första att skriva en recension'],
        ['Write a review', 'Skriv en recension'],
        ['How would you rate this product?', 'Hur skulle du betygsätta den här produkten?'],
        ['We would love it if you would share a bit about your experience.', 'Berätta gärna lite om din upplevelse.'],
        ['Review content (Required)', 'Recension (obligatoriskt)'],
        ["We'll only contact you about your review if necessary. By submitting your review, you agree to our terms and conditions and privacy policy.", 'Vi kontaktar dig bara om recensionen när det behövs. Genom att skicka in den godkänner du våra villkor och vår integritetspolicy.'],
        ['About you', 'Om dig'],
        ['Please tell us more about you.', 'Berätta gärna lite om dig.'],
        ['Email address (Required)', 'E-postadress (obligatoriskt)'],
        ['We respect your privacy.', 'Vi respekterar din integritet.'],
        ['Display name (Required)', 'Visningsnamn (obligatoriskt)'],
        ["This won't be visible to other customers.", 'Detta visas inte för andra kunder.'],
        ['Post review as anonymous', 'Publicera recensionen anonymt'],
        ['Share a picture', 'Dela en bild'],
        ['Upload a photo to support your review.', 'Ladda upp en bild till din recension.'],
        ['Click to upload or drag and drop', 'Klicka för att ladda upp eller dra och släpp'],
        ['Back', 'Tillbaka'],
        ['Next', 'Nästa'],
        ['Submit', 'Skicka'],
        ['Submit review', 'Skicka recension'],
        ['Thanks for your review!', 'Tack för din recension!'],
        ['We are processing it and it will appear on the store soon.', 'Vi behandlar den och den visas snart i butiken.'],
        ['Please confirm your email by clicking the link we just sent you. This helps us keep reviews authentic.', 'Bekräfta din e-post via länken vi just skickade. Det hjälper oss att hålla recensionerna äkta.'],
        ['Would you like to share your experience of shopping with us?', 'Vill du dela med dig av din köpupplevelse?'],
        ['We value your feedback and use it to improve. Please share any thoughts or suggestions you have.', 'Din feedback hjälper oss att bli bättre. Dela gärna dina tankar och förslag.'],
        ['Close', 'Stäng'],
      ]);
      const placeholders = new Map([
        ['Start writing here...', 'Skriv din recension här...'],
        ['Your email address', 'Din e-postadress'],
        ['Display name', 'Visningsnamn'],
      ]);
      const labels = new Map([
        ['Close review form', 'Stäng recensionsformuläret'],
        ['Review form pages', 'Sidor i recensionsformuläret'],
        ['Rating', 'Betyg'],
        ['Privacy and Terms', 'Integritet och villkor'],
        ['Review form navigation', 'Navigering i recensionsformuläret'],
        ['Previous step', 'Föregående steg'],
        ['Next step', 'Nästa steg'],
        ['Share a picture', 'Dela en bild'],
      ]);
      const translate = (root) => {
        if (!(root instanceof Element) && root !== document.body) return;
        const selector = '.jdgm-widget, .jdgm-write-review-modal, .jdgm-rev-widg';
        const scopes = root === document.body ? [...document.querySelectorAll(selector)] : [...(root.matches?.(selector) ? [root] : []), ...root.querySelectorAll(selector)];
        for (const scope of scopes) {
          const nodes = [];
          for (const element of [scope, ...scope.querySelectorAll('*')]) {
            for (const node of element.childNodes) if (node.nodeType === 3) nodes.push(node);
          }
          for (const node of nodes) {
            const value = node.nodeValue.replace(/\s+/g, ' ').trim();
            const replacement = text.get(value);
            if (!replacement) continue;
            const leading = node.nodeValue.match(/^\s*/)?.[0] || '';
            const trailing = node.nodeValue.match(/\s*$/)?.[0] || '';
            node.nodeValue = leading + replacement + trailing;
          }
          for (const element of scope.querySelectorAll('[placeholder]')) {
            const replacement = placeholders.get(element.getAttribute('placeholder'));
            if (replacement) element.setAttribute('placeholder', replacement);
          }
          for (const element of scope.querySelectorAll('[aria-label]')) {
            const value = element.getAttribute('aria-label');
            const star = value.match(/^(\d+) stars?$/);
            element.setAttribute('aria-label', star ? star[1] + ' stjärnor' : labels.get(value) || value);
            if (star && element.hasAttribute('title')) element.setAttribute('title', star[1] + ' stjärnor');
          }
          for (const element of scope.querySelectorAll('.jdgm-write-review-modal__gdpr-statement')) {
            if (!element.textContent.includes("We'll only contact you")) continue;
            element.innerHTML = 'Vi kontaktar dig bara om recensionen när det behövs. Genom att skicka in den godkänner du våra <a href="https://judge.me/terms" target="_blank" rel="nofollow noopener">villkor</a> och vår <a href="https://judge.me/privacy" target="_blank" rel="nofollow noopener">integritetspolicy</a>.';
          }
          for (const element of scope.querySelectorAll('.jdgm-write-review-modal__media-upload-prompt')) {
            if (!element.textContent.includes('Click to upload')) continue;
            element.innerHTML = '<b>Klicka för att ladda upp</b> eller dra och släpp filen här';
          }
        }
      };
      const run = () => translate(document.body);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
      else run();
      new MutationObserver(() => run()).observe(document.documentElement, { childList: true, subtree: true });
})();
